import {ParagraphNode} from './services/ParagraphNode'
import {ParagraphComponent} from './ParagraphComponent'
import {TextConverter} from '../text/services/TextConverter'
import {TextStyleCommand} from '../text/commands/TextStyleCommand'

const commandName = 'switch-to-paragraph'

const ParagraphPackage = {
    name: 'paragraph',
    configure: function(configurator, pluginConfig) {
        configurator.addNode(ParagraphNode)
        configurator.addComponent(this.name, ParagraphComponent)
        configurator.addCommand(commandName, TextStyleCommand, {textType: this.name})
        configurator.addConverter(
            TextConverter({
                type: 'paragraph',
                matchElement: (el) => {
                    return el.is('element[type="body"]') || el.is('element[type="paragraph"]')
                },
                exportAsType: 'body'
            })
        )

        configurator.addTextType({
            name: 'paragraph',
            data: {type: 'paragraph'},
            command: commandName
        })

        configurator.addLabel(this.name, {
            en: 'Paragraph',
            de: 'Paragraph'
        })

        configurator.addLabel('paragraph.content', {
            en: 'Paragraph',
            de: 'Paragraph'
        })

        configurator.addLabel('paragraph.short', {
            en: '¶',
            sv: '¶'
        })

        const combos = {
            override: pluginConfig.shortcut,
            standard: {
                'default': 'ctrl+alt+0',
                'mac': 'cmd+alt+0'
            }
        }

        // configurator.addKeyboardShortcut(combos, {command}, false, configurator.getLabelProvider().getLabel(this.name))
        configurator.addKeyboardShortcut(
            combos,
            {
                command: commandName
            },
            false,
            configurator.getLabelProvider().getLabel(this.name)
        )

    }
}


export {ParagraphPackage}
